"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var theme_1 = __importDefault(require("common/theme"));
var Money_1 = __importDefault(require("components/Money"));
var TransactionsTable_1 = __importDefault(require("containers/TableMaker/instances/TransactionsTable"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var AccordionSummary_1 = __importDefault(require("shared/components/Accordion/AccordionSummary"));
var queries_1 = require("utils/firebase/queries");
var data_1 = require("utils/selectors/data");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var AttachmentsSection = function (_a) {
    var service = _a.service;
    var _b = __read(react_1.default.useState(false), 2), showAttachments = _b[0], setShowAttachments = _b[1];
    var allTransactions = (0, react_redux_1.useSelector)((0, ordered_1.makeSelectTransactionsForService)(service.id));
    var companiesForAdminMap = (0, react_redux_1.useSelector)(data_1.selectCompaniesForAdminData);
    var latestRates = (0, react_redux_1.useSelector)(single_1.selectLatestRates);
    var currencyConverter = latestRates && (0, end2end_1.convertTransactionAmount)(latestRates, 'USD');
    var transactionsAndSpendByCompany = allTransactions && (0, mapValues_1.default)((0, groupBy_1.default)(allTransactions, 'companyId'), function (transactions) { return ({
        transactions: transactions,
        companySpend: (0, sumBy_1.default)(transactions, function (t) { return (currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter(t, 'ALL')) || 0; }),
    }); });
    var companiesTransactionsAndSpend = transactionsAndSpendByCompany && Object.entries(transactionsAndSpendByCompany)
        .map(function (_a) {
        var _b = __read(_a, 2), cId = _b[0], _c = _b[1], transactions = _c.transactions, companySpend = _c.companySpend;
        return ({
            cId: cId,
            company: companiesForAdminMap === null || companiesForAdminMap === void 0 ? void 0 : companiesForAdminMap[cId],
            transactions: transactions,
            companySpend: companySpend,
        });
    });
    companiesTransactionsAndSpend === null || companiesTransactionsAndSpend === void 0 ? void 0 : companiesTransactionsAndSpend.sort(function (tAS1, tAS2) { return tAS2.companySpend - tAS1.companySpend; });
    var totalSpend = companiesTransactionsAndSpend && (0, sumBy_1.default)(companiesTransactionsAndSpend, function (cTS) { return cTS.companySpend || 0; });
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return !showAttachments ? [] : [
        (0, queries_1.transactionsForServiceQuery)(service.id, { where: [['attachmentsFound', '==', true]] }),
        companiesTransactionsAndSpend && { collection: 'companies_for_admin', where: ['isTest', '==', false] },
    ].filter(end2end_1.notFalsy); });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ onClick: function () { return setShowAttachments(!showAttachments); } }, { children: [showAttachments ? 'Hide' : 'Show', " attachments"] })), showAttachments && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Transactions: ", allTransactions === null || allTransactions === void 0 ? void 0 : allTransactions.length, ' ', "| Attachments: ", (0, sumBy_1.default)(allTransactions, function (t) { var _a; return ((_a = t.attachmentUrls) === null || _a === void 0 ? void 0 : _a.length) || 0; }), ' ', "| Total Spend: ", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: totalSpend, currency: "USD", isShortened: "NEW" })] }), !(0, react_redux_firebase_1.isLoaded)(companiesForAdminMap) || !(0, react_redux_firebase_1.isLoaded)(allTransactions)
                        ? (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {})
                        : transactionsAndSpendByCompany && (companiesTransactionsAndSpend === null || companiesTransactionsAndSpend === void 0 ? void 0 : companiesTransactionsAndSpend.map(function (_a) {
                            var _b;
                            var cId = _a.cId, company = _a.company, transactions = _a.transactions, companySpend = _a.companySpend;
                            return ((0, jsx_runtime_1.jsxs)(Accordion_1.default, { children: [(0, jsx_runtime_1.jsxs)(AccordionSummary_1.default, { children: [(_b = company === null || company === void 0 ? void 0 : company.name) !== null && _b !== void 0 ? _b : "ID: ".concat(cId), ' ', (0, jsx_runtime_1.jsxs)("small", __assign({ style: { marginLeft: '8px' } }, { children: ["(Transactions: ", transactions.length, ' ', "| Attachments: ", (0, sumBy_1.default)(transactions, function (t) { var _a; return ((_a = t.attachmentUrls) === null || _a === void 0 ? void 0 : _a.length) || 0; }), ' ', "| Total Spend: ", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: companySpend, currency: "USD", isRounded: true }), ")"] }))] }), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, __assign({ fontSize: "0.75rem" }, { children: (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, __assign({ theme: (0, theme_1.default)(0.75) }, { children: (0, jsx_runtime_1.jsx)(TransactionsTable_1.default, { transactions: transactions }) })) }))] }, cId));
                        }))] }))] }));
};
exports.default = AttachmentsSection;
